import React, { Component } from 'react';
import { ButtonToolbar, Button, Form, FormGroup, ControlLabel, FormControl, HelpBlock, Modal } from 'react-bootstrap'
import Select from "react-select";

import { PropTypes } from 'prop-types';

export class LineDraftForm extends Component {
    static contextTypes = {
        addEditionObserver: PropTypes.func,
        removeEditionObserver: PropTypes.func
    }

    constructor(props) {
        super(props);
        this.state = {
            networkEditions: []
        };
    }

    onSave(){
        const { edition } = this.context;

        if(0 === edition.objects.network.id){
            this.setState({
                noEditionErrorShow: true
            });
            return;
        }
        this.props.onSave()
    }

    componentDidMount() {
        this.context.addEditionObserver(this);
    }

    componentWillUnmount() {
        this.context.removeEditionObserver(this);
    }

    // ----------------------

    updateDraftNetwork(edition) {
        this.setState({
            networkEditions: edition.objects.draftNetwork
        });
    }

    // ----------------------

    renderEditionFormGroup(formType, line) {
        const { networkEditions } = this.state;

        if ("create" === formType) {
            return (
                <FormGroup controlId="formEdition">
                    <ControlLabel>Edição</ControlLabel>
                    <Select
                        className="custom-multiselect"
                        placeholder="Sem Edição"
                        noOptionsMessage={() => "Sem Edições de Rascunho Configuradas"}
                        onChange={(e) => this.props.onSelectValue(null === e ? undefined : e.id, "networkEdition")}
                        options={networkEditions}
                        isMulti={false}
                        isClearable={true}
                        getOptionValue={value => value.id}
                        getOptionLabel={label => label.name}
                        value={networkEditions.find(nEdition => nEdition.id === line.networkEdition)}
                    />
                </FormGroup>
            );
        }

        return null;
    }

    render() {
        const { form } = this.props;

        if (undefined === form) {
            return null;
        }

        const { show, regions, lineColors } = this.props;

        return (
            <Modal show={show}>
                <Modal.Header>
                    <Modal.Title>
                        {form.title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        {this.renderEditionFormGroup(form.type, form.obj)}

                        <FormGroup controlId="formCode" validationState={form.codeInputError}>
                            <ControlLabel>Código</ControlLabel>
                            <FormControl
                                type="text"
                                value={form.obj.code}
                                placeholder="Introduza o código"
                                onChange={(e) => this.props.onChangeValue(e, 'code')}
                            />
                            {form.codeInputError !== null
                                ?
                                <HelpBlock> Este campo não pode estar vazio. </HelpBlock>
                                :
                                null
                            }
                        </FormGroup>
                        <FormGroup controlId="formExternalCode">
                            <ControlLabel>Código Externo</ControlLabel>
                            <FormControl
                                type="text"
                                value={form.obj.externalCode}
                                placeholder="Introduza o código externo"
                                onChange={(e) => this.props.onChangeValue(e, 'externalCode')}
                            />
                        </FormGroup>
                        <FormGroup controlId="formGoName" validationState={form.goNameInputError}>
                            <ControlLabel>Nome de Ida</ControlLabel>
                            <FormControl
                                type="text"
                                value={form.obj.goName}
                                placeholder="Introduza o nome de ida"
                                onChange={(e) => this.props.onChangeValue(e, 'goName')}
                            />
                            {form.goNameInputError !== null
                                ?
                                <HelpBlock> Este campo não pode estar vazio. </HelpBlock>
                                :
                                null
                            }
                        </FormGroup>
                        <FormGroup controlId="formReturnName">
                            <ControlLabel>Nome de Volta</ControlLabel>
                            <FormControl
                                type="text"
                                value={form.obj.returnName}
                                placeholder="Introduza o nome de volta"
                                onChange={(e) => this.props.onChangeValue(e, 'returnName')}
                            />
                        </FormGroup>
                        <FormGroup controlId="formLineRegions">
                            <ControlLabel>Regiões</ControlLabel>
                            <Select
                                className="custom-multiselect"
                                placeholder="Selecione as Regiões..."
                                noOptionsMessage={() => "Sem Regiões Configuradas"}
                                onChange={(e) => this.props.onSelectValue(e, "regions")}
                                options={regions}
                                isMulti={true}
                                isOptionSelected={function (a) {
                                    if (undefined !== form.obj.regions) {
                                        return form.obj.regions.map(region => region.id).includes(a.id);
                                    }
                                }}
                                getOptionValue={value => value}
                                getOptionLabel={label => label.name}
                                value={form.obj.regions}
                            />
                        </FormGroup>
                        <FormGroup controlId="formLineColor">
                            <ControlLabel>Cor</ControlLabel>
                            <Select
                                className="custom-multiselect"
                                placeholder="Sem Cor"
                                noOptionsMessage={() => "Sem Cores Configuradas"}
                                onChange={(e) => this.props.onSelectValue(e, "lineColor")}
                                options={lineColors}
                                isMulti={false}
                                isClearable={true}
                                isOptionSelected={function (a) {
                                    if (null !== form.obj.lineColor && undefined !== form.obj.lineColor) {
                                        return form.obj.lineColor.id === a.id;
                                    }
                                }}
                                getOptionValue={value => value}
                                getOptionLabel={label => label.name}
                                value={form.obj.lineColor}
                            />
                        </FormGroup>
                    </Form>

                    <ButtonToolbar>
                        {
                            this.state.noEditionErrorShow &&
                            <div style={{color:'red', marginLeft:'5px'}}>É necessário uma Edição de Rascunho para poder criar uma linha</div>
                        }
                        <Button onClick={() => this.onSave()}> GUARDAR ALTERAÇÕES </Button>
                        <Button onClick={() => this.props.onHide()}> CANCELAR </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/lines/LineDraftForm.js